import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { IconButton } from 'atoms/buttons/IconButton';
import { ResponsiveImg } from 'atoms/ui/ResponsiveImg';
import { ANY_SPORT_PLAYERS_SLUG_CARDS } from 'constants/__generated__/routes';
import { useScreenSize } from 'hooks/device/useScreenSize';
import type { PlayerHit } from 'lib/algolia';
import { AlgoliaSportsMappings } from 'lib/algolia';
import { glossary } from 'lib/glossary';
import { generateSportPath } from 'lib/routing/generateSportPath';

import { Suggestion } from '../Suggestion';
import { Cards } from './cards';

interface Props {
  hit: PlayerHit;
  isHighlighted: boolean;
  onClose?: () => void;
}

const StyledResponsiveImg = styled(ResponsiveImg)`
  height: 40px;
`;

export const PlayerSuggestion = ({ hit, isHighlighted, onClose }: Props) => {
  const { up: isTablet } = useScreenSize('tablet');

  const buttonProps = {
    color: 'tertiary' as const,
    to: generateSportPath(ANY_SPORT_PLAYERS_SLUG_CARDS, {
      params: { slug: hit.objectID },
      sport: AlgoliaSportsMappings[hit.sport],
    }),
    onClick: (evt: React.MouseEvent<HTMLButtonElement>) => {
      evt.stopPropagation();
      onClose?.();
    },
  };

  return (
    <Suggestion
      isHighlighted={isHighlighted}
      renderAvatar={Img =>
        hit.avatarUrl ? (
          <div className="text-center">
            <StyledResponsiveImg
              cropWidth={40}
              src={hit.avatarUrl}
              alt={hit.display_name}
            />
          </div>
        ) : (
          <Img src={hit.avatarUrl} alt={hit.display_name} isContain />
        )
      }
      primary={hit.display_name}
      secondary={hit.activeClub ? hit.activeClub.name : ''}
      cta={
        isTablet ? (
          <Button {...buttonProps} startIcon={<Cards />} size="compact">
            <FormattedMessage {...glossary.cards} />
          </Button>
        ) : (
          <IconButton size="medium" {...buttonProps}>
            <Cards size={2} />
          </IconButton>
        )
      }
    />
  );
};
